"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BRAND_SHADOW = exports.DEFAULT_BRAND_BACKGROUND = void 0;
exports.DEFAULT_BRAND_BACKGROUND = {
    image: null,
    color: 'var(--brand-primaryBackgroundColor)',
    repeat: 'no-repeat',
    position: 'center',
    objectFit: 'auto',
    attachment: 'fixed',
    overlay: null,
};
exports.DEFAULT_BRAND_SHADOW = {
    preset: 'none',
    size: 0,
    color: 'var(--brand-borderColor)',
};
